module.exports = __webpack_public_path__ + "static/media/act-2.28ccd19f.pdf";